import { Link } from '@cbhq/cds-web/typography/Link';
import { Image, HighlightImageText as HighlightImageText$1 } from '@cbhq/cdx-components';
import { getComposePageSeoImageUrlAndDescription } from '../globals/composePage.js';
import { mapEntryLink } from '../globals/navlink.js';
import { jsx } from 'react/jsx-runtime';
const HIGHLIGHT_IMAGE_TEXT_CONTENT_MODEL_ID = 'cdxHighlightImageText';
const layoutMap = {
  Left: 'left',
  Right: 'right',
  Stacked: 'stacked',
  Vertical: 'vertical'
};
function HighlightImageText({
  headline,
  list,
  listStyle,
  eyebrow,
  subhead,
  legalText,
  media,
  imageFit,
  link,
  layout,
  style,
  anchor,
  ctaButtonLabel,
  ctaButtonUrl,
  hasSpacingTop = true,
  hasLightbox,
  logoList,
  svgHeadline,
  svgElementName
}) {
  const navLink = link && mapEntryLink(link);
  const logos = logoList && logoList.map(({
    fields: {
      link,
      icon
    }
  }, index) => {
    const logoLink = mapEntryLink(link);
    const _getComposePageSeoIma = getComposePageSeoImageUrlAndDescription(link?.fields?.composePage),
      url = _getComposePageSeoIma.url,
      description = _getComposePageSeoIma.description;
    const imageSrc = icon?.fields?.file?.url || url;
    const imageAlt = icon?.fields?.description || description;
    return /*#__PURE__*/jsx(Link, {
      href: logoLink?.url,
      children: /*#__PURE__*/jsx(Image, {
        alt: imageAlt,
        src: imageSrc,
        maxWidth: [180, 230],
        imageFit: "contain"
      })
    }, logoLink?.url + index);
  });
  return /*#__PURE__*/jsx(HighlightImageText$1, {
    eyebrow: eyebrow,
    headline: headline,
    subhead: subhead,
    list: list,
    listStyle: listStyle,
    legalText: legalText,
    mediaUrl: media?.fields.file?.url,
    mediaAlt: media?.fields.title,
    imageFit: imageFit,
    layout: layoutMap[layout],
    ctaButtonLabel: ctaButtonLabel,
    ctaButtonUrl: ctaButtonUrl,
    secondaryButtonLabel: navLink?.label,
    secondaryButtonUrl: navLink?.url,
    hasSpacingTop: hasSpacingTop,
    style: style,
    anchor: anchor,
    hasLightbox: hasLightbox,
    logoList: logos,
    svgHeadline: svgHeadline,
    svgElementName: svgElementName,
    mediaType: svgElementName ? 'svg' : 'image'
  });
}
export { HIGHLIGHT_IMAGE_TEXT_CONTENT_MODEL_ID, HighlightImageText };
//# sourceMappingURL=HighlightImageText.js.map
